
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/haulers",
      function () {
        return require("private-next-pages/haulers.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/haulers"])
      });
    }
  